<template>
  <div v-if="!isLoading">
    <vs-row class="mb-5">
      <div class="flex justify-end w-full">
        <router-link :to="`/editar-evento/${formData.idEvento}`">
          <vs-button
            type="flat"
            v-if="$can($actionsDefault.Leitura, 'Eventos')"
          >
            Ir para Edição
          </vs-button>
        </router-link>
      </div>
    </vs-row>

    <!-- Card's -->
    <vs-row class="mt-5">
      <EventosCard :dadosEvento="formData" />
      <AssociadoCard :dadosEvento="formData" />
      <VeiculoCard :dadosEvento="formData" />
    </vs-row>

    <div v-if="1 == 2">
      {{ formData }}
    </div>

    <vs-row class="mt-5">
      <vx-card>
        <EventosAnaliseForm :formData="formData" :dominios="dominios" />

        <TerceirosList
          :idEvento="formData.idEvento"
          :terceiros="formData.terceiros"
          :modeAnalise="true"
        />

        <DadosEventosForm :formData="formData" />

        <LocalEventoForm :formData="formData" />

        <AnaliseBoletosList :listBoletos="formData.listBoletos" />

        <VeiculosList :listVeiculos="formData.listVeiculos" />

        <ProdutosList :listProdutos="formData.listProdutos" />

        <BoletimOcorrencia :formData="formData" :dominios="dominios" />

        <FotosDocumentos
          :formData="formData"
          :arquivos="formData.listFotosDocumentos"
          :idReferente="idReferenteEvento"
          :title="`Fotos do Veículo Segurado`"
        />

        <div
          v-for="(element, index) in formData.listFotosDocumentosTerceiros"
          :key="index"
        >
          <FotosDocumentos
            :formData="element"
            :arquivos="element.listFotosDocumentos"
            :idReferente="idReferenteTerceiro"
            :title="`Fotos do Veículo Terceiro: ${element.nome || ''}`"
          />
        </div>

        <LocalEventoView :formData="formData" />

        <AnaliseTecnicaForm :formData="formData" :dominios="dominios" />
      </vx-card>
    </vs-row>

    <!-- Botão Salvar -->
    <vs-row class="mt-5">
      <div class="flex justify-end w-full">
        <div>
          <BotaoSubmit
            v-if="$can($actionsDefault.Escrita, 'Análise de Eventos')"
            text="Salvar Alterações"
            :variant="'success'"
            :edit="!loadingButton"
            :aguarde="loadingButton"
            class="ml-4"
            @submit="submit()"
          ></BotaoSubmit>
        </div>
      </div>
    </vs-row>
  </div>
</template>

<script>
import service from './../../../../services';
import notify from './../../../../utils/notify';
import serviceEventos from './../shared/service';
import {
  FOTO_REFERENTE_EVENTO,
  FOTO_REFERENTE_TERCEIROS,
} from './../shared/const';

// Component
import AssociadoCard from '../shared/components/card/AssociadoCard.vue';
import EventosCard from '../shared/components/card/EventoCard.vue';
import VeiculoCard from '../shared/components/card/VeiculoCard.vue';

import AnaliseBoletosList from './components/AnaliseBoletosList.vue';
import AnaliseTecnicaForm from './components/AnaliseTecnicaForm.vue';
import BoletimOcorrencia from './components/BoletimOcorrenciaForm.vue';
import DadosEventosForm from './components/DadosEventosForm.vue';
import EventosAnaliseForm from './components/EventosAnaliseForm.vue';
import FotosDocumentos from './../shared/components/FotosDocumentos.vue';
import LocalEventoForm from './../shared/components/LocalEventoForm.vue';
import LocalEventoView from './components/LocalEventoView.vue';
import ProdutosList from './components/ProdutosList.vue';
import TerceirosList from './../shared/components/TerceirosList.vue';
import VeiculosList from './components/VeiculosList.vue';
import BotaoSubmit from './../../../../components/BotaoSubmit.vue';

export default {
  components: {
    AssociadoCard,
    EventosCard,
    VeiculoCard,
    AnaliseBoletosList,
    AnaliseTecnicaForm,
    BoletimOcorrencia,
    DadosEventosForm,
    EventosAnaliseForm,
    FotosDocumentos,
    LocalEventoForm,
    LocalEventoView,
    ProdutosList,
    TerceirosList,
    VeiculosList,
    BotaoSubmit,
  },
  data() {
    return {
      isLoading: true,
      loadingButton: false,
      dominios: {
        listUsuarios: [],
        listMonta: [],
      },
      formData: {
        idEvento: null,
        protocolo: null,
        dadosCliente: {},
        dadosVeiculo: {},
        dadosGerais: {},
        dadosAnalise: {},
        condutor: {},
        terceiros: [],
        dadosEventos: {},
        enderecoEvento: {},
        novoLocalEvento:{},
        listLocaislEvento:[],
        boletimOcorrencia: {},
        listFotosDocumentos: [],
        listFotosCroqui: [],
        listFotosDocumentosTerceiros: null,
        analiseTecnica: {},
        listBoletos: [],
        listProdutos: [],
        listVeiculos: [],
      },
      idReferenteEvento: FOTO_REFERENTE_EVENTO,
      idReferenteTerceiro: FOTO_REFERENTE_TERCEIROS,
    };
  },
  methods: {
    async getDominis() {
      try {
        this.$vs.loading();

        const promises = [
          serviceEventos.getListUsuarios(),
          serviceEventos.getListDominio('domEventosMonta', 'monta', 'idMonta'),
        ];

        const [listUsuarios, listMonta] = await Promise.all(promises);

        this.dominios.listUsuarios = listUsuarios;
        this.dominios.listMonta = listMonta;
      } catch (error) {
        console.error(error);
        notify.notifyFail(this.$vs, 'Falha ao carregar os dados do evento');
      } finally {
        this.$vs.loading.close();
      }
    },
    async getEvento() {
      const { idEvento } = this.$route.params;

      if (!idEvento) {
        return;
      }

      try {
        this.$vs.loading();

        const result = await service.getAll(
          'eventos2',
          null,
          `analise/${idEvento}`,
        );
        const evento = result.data;

        if (!evento) {
          notify.notifyFail(
            this.$vs,
            'Você não tem acesso a visualização deste Evento',
          );
          this.$vs.loading.close();
          return;
        }

        this.isLoading = false;

        this.$nextTick(() => {
          this.formData = evento;
        });
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    async submit() {
      try {
        this.$vs.loading();

        const data = { ...this.formData };

        const dataEvento = await service.post(
          'eventos2',
          'analise/update-evento',
          data,
        );

        this.formData = dataEvento.data;
        notify.notifySuccess(this.$vs, 'Evento salvo com sucesso!');
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  async mounted() {
    await this.getDominis();
    await this.getEvento();
  },
};
</script>

<style lang="scss">
.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;
  tr td {
    padding: 2px;
  }
  tr:nth-child(2n) {
    background: #efefef !important;
  }
}
</style>
